import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of, lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators'
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { ConfirmationService } from 'primeng/api';
import { OrganizationSubscriptionService } from '../modules/shared/services/organization-subscription.service';
import { FeatureSubscriptionInfoEnums } from '../modules/shared/enums/feature-subscription-info.enum';
import { SubscriptionFeatureLimitM } from '../modules/shared/models/organization-subscription/subscription-feature-limit.modal';
@Injectable({ providedIn: 'root' })
export class PermissionService {
    private userPermissionsBSubject: BehaviorSubject<any>;
    public userReportsPermissionsBSubject: BehaviorSubject<any>;
    private channelPermissionCount: BehaviorSubject<SubscriptionFeatureLimitM>;
    currentUser;
    appOrgUrl = "";
    encryptSecretKey = "LionO3602.0CRM2021";
    globalChannelId: number | null = null;

    constructor(
        private router: Router,
        private http: HttpClient,
        private confirmationService: ConfirmationService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) {
        this.appOrgUrl = environment.appOrgUrl;
        this.userPermissionsBSubject = new BehaviorSubject<any>([]);
        this.userReportsPermissionsBSubject = new BehaviorSubject<any>([]);
        this.channelPermissionCount = new BehaviorSubject<SubscriptionFeatureLimitM>(null);
        this.currentUser = this.decode(localStorage.getItem('liono360'))
    }


    decode(data) {
        if (data) {
            const decrypted = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
            if (decrypted) {
                try {
                    const str = decrypted.toString(CryptoJS.enc.Utf8);
                    if (str.length > 0) {
                        return JSON.parse(str);
                    } else {
                        return 'error 1';
                    }
                } catch (e) {
                    return 'error 2';
                }
            }
            return 'error 3';
        }
    }

    getPermissionData() {
        const data = this.userPermissionsBSubject.getValue();
        if (data.length) {
            return data;
        } else {
            const permissionData = localStorage.getItem('userPermissions') ? JSON.parse(localStorage.getItem('userPermissions')) : [];
            return permissionData;
        }
    }

    setPermissionData(permissions: any): any {
        this.userPermissionsBSubject.next(permissions);
    }

    getPermissionUpdatedSignal(): Observable<any>{
        return this.userPermissionsBSubject.asObservable();
    }

    getPemrissionData() {
        const data = this.userPermissionsBSubject.getValue();
        if (data.length) {
            return data;
        } else {
            const permissionData = localStorage.getItem('userPermissions') ? JSON.parse(localStorage.getItem('userPermissions')) : [];
            return permissionData;
        }
    }

    getReportsPemrissionData() {
        const data = this.userReportsPermissionsBSubject.getValue();
        if (data.length) {
            return data;
        } else {
            return null;
        }
    }

    getReportsPermissionByChannel(){
        const userReportsPermissions = this.userReportsPermissionsBSubject.getValue()||[];
        const globalChannelId = this.getGlobalChannelId();
        let defaultReportPermission = null;

        if (typeof globalChannelId === 'number'){
            defaultReportPermission = userReportsPermissions.find(x => x?.channelId === globalChannelId)?.channelPermission;
        }
        else {
            defaultReportPermission = userReportsPermissions.find(x => x?.isDefault === true)?.channelPermission;
        }

        return defaultReportPermission||[];
    }

    getHeader() {

        let randomstr = localStorage.getItem("randomstr");
        if (!this.currentUser) {
            this.currentUser = this.decode(localStorage.getItem('liono360'))
        }
        let headers = new HttpHeaders({
            'organizationId': this.currentUser.organizationId + '',
            'userId': this.currentUser.userId + '',
            'loginAuditId': this.currentUser.loginAuditId + '',
            'authToken': this.currentUser.token + '',
            'sessionId': randomstr,
            'sourceType': 'Web',
            'userSource': this.currentUser.userIP
        });
        let options = {
            headers: headers
        };
        return options;
    }

    getUserPermissions(users?) {
        if (users) {
            this.currentUser = users;
        }
        if (!this.currentUser) {
            this.currentUser = this.decode(localStorage.getItem('liono360'));
            // console.log(this.currentUser)
        }
        // return this.http.get<any>(`${this.appOrgUrl}UserPermission?userId=${this.currentUser.userId}`)
        //     .pipe(
        //         map(resp => {
        //             localStorage.setItem('userPermissions', JSON.stringify(resp));
        //             this.userPermissionsBSubject.next(resp);
        //             return resp;
        //         })
        //     )
        return this.http.get<any>(`${this.appOrgUrl}UserProfilePermission/AllPermission/${this.currentUser.userId}`)
            .pipe(
                map(resp => {
                    const permissionJSON: any = resp;
                    localStorage.setItem('allChannelsUserPermissions', JSON.stringify(permissionJSON));

                    const selectedChannel = JSON.parse(localStorage.getItem('selectedGlobalChannel'))||null;
                    let defaultPermission = permissionJSON.find((obj) => obj?.isDefault === true);

                    if(selectedChannel && selectedChannel?.userId==this.currentUser.userId && selectedChannel?.channelId){
                        defaultPermission = permissionJSON.find((obj) => obj?.channelId === selectedChannel?.channelId)||defaultPermission;
                    }

                    localStorage.setItem('selectedGlobalChannel', JSON.stringify({
                        userId: this.currentUser.userId,
                        channelId: defaultPermission.channelId
                    }));
                    localStorage.setItem('userPermissions', JSON.stringify(defaultPermission?.channelPermission));
                    this.userPermissionsBSubject.next(defaultPermission?.channelPermission);
                    return defaultPermission?.channelPermission;
                })
        )
    }

    changeUserPermissionByChannel(channelId: number): boolean | string {
        const allChannelPermission = JSON.parse(localStorage.getItem('allChannelsUserPermissions'));
        let selectedChannelPermission: any;
        if (channelId === 0){
            selectedChannelPermission = allChannelPermission?.find((obj) => obj?.isDefault === true)?.channelPermission;
        }
        else {
            selectedChannelPermission = allChannelPermission?.find((obj) => obj?.channelId === channelId)?.channelPermission;
            if (selectedChannelPermission === undefined){
                return 'newPermission';
            }

            if(selectedChannelPermission){
                this.setGlobalChannelId(channelId);
            }
        }
        localStorage.setItem('userPermissions', JSON.stringify(selectedChannelPermission));
        this.setPermissionData(selectedChannelPermission);
        const isUserPermissionKeyAvailable = !!localStorage.getItem('userPermissions');
        if (isUserPermissionKeyAvailable){
            return true;
        }
        else {
            return false;
        }
    }

    filterChannelsByPermissions(channels: any[], objectName: string){
        const permittedChannels: any[] = [];
        const allChannelPermission = JSON.parse(localStorage.getItem('allChannelsUserPermissions')||'[]');

        channels.map(channel=>{
            const userPermissions = allChannelPermission?.find((obj) => obj?.channelId === channel.id)?.channelPermission;
            let permitted: boolean = true;
            if (userPermissions?.length) {
                let objectPermission = userPermissions.find(obj => obj.objectName === objectName);
                objectPermission = objectPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
                const readPermission = objectPermission && (objectPermission[0].permissionId == 1 && objectPermission[0].statusId == 1);
                const writePermission = objectPermission && (objectPermission[1].permissionId == 2 && objectPermission[1].statusId == 1);
                const editPermission = objectPermission && (objectPermission[2].permissionId == 3 && objectPermission[2].statusId == 1);
                const deletePermission = objectPermission && (objectPermission[3].permissionId == 4 && objectPermission[3].statusId == 1);
                const exportPermission = objectPermission && (objectPermission[4].permissionId == 5 && objectPermission[4].statusId == 1);

                permitted = (readPermission || writePermission || editPermission || deletePermission || exportPermission) as boolean;
            }

            permitted && permittedChannels.push(channel);
        })

        return permittedChannels;
    }

    filterChannelsByReportPermissions(channels: any[], reportName: string){
        const permittedChannels: any[] = [];
        const userReportsPermissions = this.getReportsPemrissionData()||[];

        channels.map(channel=>{
            const reportPermissionData = userReportsPermissions.find(x => x?.channelId === channel.id)?.channelPermission||[];
            const reportPermission = reportPermissionData.find(c => c.objectName == reportName);
            let permitted: boolean = reportPermissionData.length==0 ? true : false;

            if(reportPermission && (reportPermission.permissions.filter(x => x.permissionName == 'Read')[0].statusId == 1)){
                permitted = true;
            }

            permitted && permittedChannels.push(channel);
        })

        return permittedChannels;
    }

    popUpMsg(): any{
        this.confirmationService.confirm({
            message: 'New channel permission has been added, you need Logout and then Login again',
            header: 'Error',
            icon: 'pi pi-info-circle',
            accept: () => {
               console.log('log out');
               return true;
            },
            acceptLabel: 'Log Out',
            reject: () => {
                return false;
            }
        });
    }

    setGlobalChannelId(channelId: number){
        let selectedChannel = JSON.parse(localStorage.getItem('selectedGlobalChannel')||'{}');
        if(selectedChannel?.channelId){
            selectedChannel.channelId = channelId;
            localStorage.setItem('selectedGlobalChannel',JSON.stringify(selectedChannel));
        }

        this.globalChannelId = channelId;
    }

    getGlobalChannelId(): number | null {
        const selectedChannel = JSON.parse(localStorage.getItem('selectedGlobalChannel')||'{}');

        if(selectedChannel?.channelId){
            this.globalChannelId = selectedChannel?.channelId;
            return this.globalChannelId;
        }

        return this.globalChannelId||null;
    }

    isChannelIdSet(): boolean {
        const selectedChannel = JSON.parse(localStorage.getItem('selectedGlobalChannel')||'{}');

        if(selectedChannel?.channelId){
            this.globalChannelId = selectedChannel?.channelId;
        }

        return !!this.globalChannelId;
    }

    async getChannelPermissionsCount(forceReload: boolean = false){
        const channelPermissionCount = this.channelPermissionCount?.getValue();
        if (channelPermissionCount && !forceReload) {
            return this.channelPermissionCount?.getValue();
        } else {
            await lastValueFrom(this.organizationSubscriptionService
            .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Channel,1)).then(response=>{
                this.channelPermissionCount.next(response);
            });
            return this.channelPermissionCount?.getValue();
        }
    }


}
